export const RESET = 'EXSBSETTLEMENT_UPDATE_RESET'
export const SET_ERROR = 'EXSBSETTLEMENT_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBSETTLEMENT_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBSETTLEMENT_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBSETTLEMENT_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBSETTLEMENT_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBSETTLEMENT_UPDATE_UPDATE_RETRIEVED'
